import { useSelector } from "react-redux"
import { IStoreState } from "../redux/initialStoreState"

export const useDashboard = () => {
    return useSelector((storeState: IStoreState) => storeState.dashboard);
}

export const useMetric = (key: string) => {
    return useSelector((storeState: IStoreState) => storeState.dashboard.metrics[key]);
}



export const useRenewalCount = () => {
    return useSelector((storeState: IStoreState) => storeState.dashboard.renewalCount);
}

export const useBinderCount = () => {
    return useSelector((storeState: IStoreState) => storeState.dashboard.binderCount);
}

export const useNoticeAndEdocCount = () => {
    return useSelector((storeState: IStoreState) => storeState.dashboard.noticeAndEdocCount);
}
